<template>
    <div>
        <div style="display:flex;justify-content: start;margin-top: 5px;font-size:15px; color: black;">
            Input Product Details
        </div>
        <span style="color: #6B7280;font-size:12px">Edit details of product</span>
        <div style="margin-top: 30px;margin-bottom:30px;">
            <a-spin :spinning="loading">
                <a-form-model ref="addInputProductDtailsForm" :model="addInputProductDtails" :rules="rules">
                    <a-row type="flex" justify="start">
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Product Name" ref="productName" prop="productName">
                                <a-input v-model="addInputProductDtails.productName" />
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="10" :offset="1">
                            <a-form-model-item label="Generic Name" ref="genericName" prop="genericName">
                                <a-input v-model="addInputProductDtails.genericName" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row type="flex" justify="start">
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Suppliers" ref="supplier" prop="supplier">
                                <a-select @change="OnSelectSupplier" v-model="addInputProductDtails.supplier"
                                    placeholder="please select your supplier">
                                    <a-select-option v-for="supplier in suppliers" :key="supplier.id"
                                        v-bind:value="supplier.id">
                                        {{ supplier.name }}
                                    </a-select-option>
                                    <a-select-option value="other">
                                        Other
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="1">
                            <a-form-model-item label="Manufacturer" ref="manufactuer" prop="manufactuer">
                                <a-select @change="OnSelectManufacturer" v-model="addInputProductDtails.manufactuer"
                                    placeholder="please select your manufactuer">
                                    <a-select-option v-for="manufactuer in manufactuers" :key="manufactuer.id"
                                        v-bind:value="manufactuer.id">
                                        {{ manufactuer.name }}
                                    </a-select-option>
                                    <a-select-option value="other">
                                        Other
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    <a-row type="flex" justify="start">
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Product Type" ref="productType" prop="productType">
                                <a-select v-model="addInputProductDtails.productType"
                                    placeholder="please select your choice">
                                    <a-select-option value="0">
                                        Service
                                    </a-select-option>
                                    <a-select-option value="1">
                                        Product
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="1">
                            <a-form-model-item label="Country as Labelled" ref="country" prop="country">
                                <country-select className="countryStyle" v-model="addInputProductDtails.country"
                                    :country="country" topCountry="GH" />

                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    <a-row type="flex" justify="start">
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Unit Quantity" ref="unitQuantity" prop="unitQuantity">
                                <a-input-number class="numberInput" v-model="addInputProductDtails.unitQuantity" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="1">
                            <a-form-model-item label="Unit Measure" ref="measure" prop="measure">
                                <a-select v-model="addInputProductDtails.measure"
                                    placeholder="please select your measure">
                                    <a-select-option value="1">
                                        Grams
                                    </a-select-option>
                                    <a-select-option value="2">
                                        Kilograms
                                    </a-select-option>
                                    <a-select-option value="3">
                                        Millilitres
                                    </a-select-option>
                                    <a-select-option value="4">
                                        Litres
                                    </a-select-option>
                                    <a-select-option value="5">
                                        Pieces
                                    </a-select-option>
                                    <a-select-option value="6">
                                        Boxes
                                    </a-select-option>
                                    <a-select-option value="7">
                                        Doses
                                    </a-select-option>
                                    <a-select-option value="0">
                                        Unknown
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row type="flex" justify="start">
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Unit Weight" ref="weight" prop="weight">
                                <a-input class="numberInput" v-model="addInputProductDtails.weight" addon-after="KG">
                                </a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="1">
                            <a-form-model-item label="Selling Price(Ksh)" ref="sellingPrice" prop="sellingPrice">
                                <a-input-number class="numberInput" v-model="addInputProductDtails.sellingPrice" />
                            </a-form-model-item>
                        </a-col>

                    </a-row>
                    <a-row>
                        <a-col :span="21" :offset="0">
                            <a-form-model-item label="Short Description" ref="shortDesc" prop="shortDesc">
                                <a-textarea class="descInputText" v-model="addInputProductDtails.shortDesc"
                                    placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" />
                            </a-form-model-item>

                        </a-col>
                    </a-row>

                    <a-row type="flex" justify="start">
                        <a-col :span="21" :offset="0">
                            <a-form-model-item label="Other Details" ref="otherDetails" prop="otherDetails">
                                <a-textarea class="descInputText" v-model="addInputProductDtails.otherDetails"
                                    placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    <a-row type="flex" justify="start">
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Cost Price(Ksh)" ref="costPrice" prop="costPrice">
                                <a-input-number class="numberInput" v-model="addInputProductDtails.costPrice" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="1">
                            <a-form-model-item label="Special Storage Required?" ref="storageRequired"
                                prop="storageRequired">
                                <a-select @change="onChangeStorage" v-model="addInputProductDtails.storageRequired"
                                    placeholder="please select your choice">
                                    <a-select-option value="true">
                                        Yes
                                    </a-select-option>
                                    <a-select-option value="false">
                                        No
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    <a-row v-show="showRequirement" type="flex" justify="start">
                        <a-col :span="20">
                            <a-form-model-item label="Enter Requirement?" ref="requirement" prop="requirement">
                                <a-textarea class="descInputText" v-model="addInputProductDtails.requirement"
                                    placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>

                <div style="display:flex;justify-content: start;">
                    <a-button @click="saveProductInfo" style="background: #418a49;height:45px;color:#fff;width:256px;">
                        Save & Continue
                    </a-button>
                </div>
            </a-spin>
        </div>
        <a-modal class="modalStyle" :visible="isSupplierVisible" :footer="null" @cancel="handleAddSupplierCancel">
            <h4 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Submit Supplier</h4>
            <div>
                <a-form-model ref="addSupplierform" :model="newSupplier" :rules="rules">
                    <a-row style="padding:30px">
                        <a-col>
                            <a-form-model-item label="Name" ref="name" prop="name">
                                <a-input class="" v-model="newSupplier.name" />
                            </a-form-model-item>
                        </a-col>
                        <a-col>
                            <a-form-model-item label="Address" ref="address" prop="address">
                                <a-textarea class="descInputText" v-model="newSupplier.address" placeholder=""
                                    :auto-size="{ minRows: 3, maxRows: 5 }" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    <a-form-model-item
                        style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                        <a-button @click="submitSupplier" :loading="loading"
                            style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                            Submit
                        </a-button>
                    </a-form-model-item>

                </a-form-model>
            </div>
        </a-modal>

        <a-modal class="modalStyle" :visible="isManufacturerVisible" :footer="null"
            @cancel="handleAddManufcturerCancel">
            <h4 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Submit Manufacturer
            </h4>
            <div>
                <a-form-model ref="addManufacturerform" :model="newManufacturer" :rules="rules">
                    <a-row style="padding:30px">
                        <a-col>
                            <a-form-model-item label="Name" ref="name" prop="name">
                                <a-input class="" v-model="newManufacturer.name" />
                            </a-form-model-item>
                        </a-col>
                        <a-col>
                            <a-form-model-item label="Description" ref="desc" prop="desc">
                                <a-textarea class="descInputText" v-model="newManufacturer.desc" placeholder=""
                                    :auto-size="{ minRows: 3, maxRows: 5 }" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    <a-form-model-item
                        style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                        <a-button @click="submitManufacturer" :loading="loading"
                            style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                            Submit
                        </a-button>
                    </a-form-model-item>

                </a-form-model>
            </div>
        </a-modal>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "EditProductDetails",
    data() {
        return {
            loading: false,
            manufactuers: [],
            suppliers: [],
            categories: [],
            showRequirement: false,
            layout: 'horizontal',
            newSupplier: {
                name: "",
                address: "",

            },
            newManufacturer: {
                name: '',
                desc: ''
            },
            country: "",
            isSupplierVisible: false,
            isManufacturerVisible: false,
            addInputProductDtails: {
                productName: "",
                genericName: "",
                productType: "",
                supplier: "",
                manufactuer: "",
                country: "",
                unitQuantity: "",
                requirement: "",
                measure: "",
                weight: "",
                shortDesc: "",
                otherDetails: "",
                storageRequired: "",
                sellingPrice: "",
                costPrice: "",
                metadata: {}
            },
            newSupplierId: "",
            newManufacturerId: "",
            rules: {
                supplier: [
                    { required: true, message: 'Please choose your supplier', trigger: 'change' }
                ],
                storageRequired: [
                    { required: true, message: 'Please choose your choice', trigger: 'change' }
                ],
                shortDesc: [
                    { required: true, message: 'Please enter short description', trigger: 'change' },
                    { max: 260, message: 'Maximum characters is 100', trigger: 'change' },
                ],
                otherDetails: [
                    { required: true, message: 'Please enter other description', trigger: 'change' },
                    { max: 1000, message: 'Maximum characters is 100', trigger: 'change' },
                ],
                manufactuer: [
                    { required: true, message: 'Please choose your manufactuer', trigger: 'change' }
                ],
                country: [
                    { required: true, message: 'Please choose country', trigger: 'change' }
                ],
                unitQuantity: [
                    { required: true, message: 'Please enter unit quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                measure: [
                    { required: true, message: 'Please enter unit measurement', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                sellingPrice: [
                    { required: true, message: 'Please enter selling price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                costPrice: [
                    { required: true, message: 'Please enter cost price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],

                weight: [
                    { required: true, message: 'Please enter weight', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                productName: [
                    { required: true, message: 'Please enter product name', trigger: 'change' },
                    { max: 100, message: 'Maximum characters is 100', trigger: 'change' },
                ],
                name: [
                    { required: true, message: 'Please enter supplier name', trigger: 'change' }
                ],
                address: [
                    { required: true, message: 'Please enter supplier address', trigger: 'change' }
                ],
                phoneNumber: [
                    { required: true, message: 'Please enter supplier phone number', trigger: 'change' }
                ],
                genericName: [
                    { required: true, message: 'Please choose generic brand', trigger: 'change' }
                ],
                productType: [
                    { required: true, message: 'Please choose your product type', trigger: 'change' }
                ],
            },

        }
    },
    computed: {
        ...mapGetters(['getProductDetailsInfo', 'getProductGroupInfo', 'getCatalog']),
        formItemLayout() {

            return this.layout === 'horizontal'
                ? {
                    labelCol: { span: 9 },
                    wrapperCol: { span: 14 },
                }
                : {};
        },
    },
    methods: {
        ...mapActions(['setStepCount', 'addSupplier', 'addManufacturer', 'finalCategoryManufacturerSupplierList', 'setProductDetailsInfo', 'updateProduct']),
        submitSupplier() {
            this.$refs.addSupplierform.validate(valid => {
                if (valid) {
                    this.loading = true
                    let request_data = {
                        name: this.newSupplier.name,
                        address: this.newSupplier.address,
                        metadata: {},
                        status: 0
                    }
                    this.addSupplier(request_data).then(response => {
                        this.loading = false;
                        // console.log("suppler add  | ", response)
                        if (response.status === 200) {
                            this.newSupplierId = response.data.id
                            this.isSupplierVisible = false
                        } else {
                            console.log("Error | ", response)
                        }
                    }, error => {
                        this.loading = false
                        console.log("Error | ", error)
                    })
                } else {
                    return false
                }
            })
        },
        submitManufacturer() {
            this.$refs.addManufacturerform.validate(valid => {
                if (valid) {
                    this.loading = true
                    let request_data = {
                        name: this.newManufacturer.name,
                        description: this.newManufacturer.desc,
                        status: 0
                    }
                    // console.log("request_data  | ", request_data)
                    this.addManufacturer(request_data).then(response => {
                        this.loading = false;
                        // console.log("suppler add  | ", response)
                        if (response.status === 200) {
                            this.newManufacturerId = response.data.id
                            this.isManufacturerVisible = false
                        } else {
                            console.log("Error | ", response)
                        }
                    }, error => {
                        this.loading = false
                        console.log("Error | ", error)
                    })
                } else {
                    return false
                }
            })
        },
        saveProductInfo() {
            this.$refs.addInputProductDtailsForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    let request_final_data = {
                        productId: this.getCatalog.id,
                        request_data: {
                            categoryId: this.getProductGroupInfo.categoryId,
                            manufacturerId: this.addInputProductDtails.manufactuer === "other" ? this.newManufacturerId : this.addInputProductDtails.manufactuer,
                            supplierId: this.addInputProductDtails.supplier === "other" ? this.newSupplierId : this.addInputProductDtails.supplier,
                            brandName: this.addInputProductDtails.productName,
                            genericName: this.addInputProductDtails.genericName,
                            sellingPrice: parseFloat(this.addInputProductDtails.sellingPrice),
                            purchasePrice: parseFloat(this.addInputProductDtails.costPrice),
                            strength: '',
                            details: this.addInputProductDtails.otherDetails,
                            productType: parseInt(this.addInputProductDtails.productType),
                            unit: parseInt(this.addInputProductDtails.measure),
                            unitQuantity: parseInt(this.addInputProductDtails.unitQuantity),
                            isTaxable: true,
                            tax: 0,
                            isSpecial: this.addInputProductDtails.storageRequired === "true" ? true : false,
                            country: this.addInputProductDtails.country,
                            shortDescription: this.addInputProductDtails.shortDesc,
                            unitWeight: parseInt(this.addInputProductDtails.weight),
                            specialRequirement: this.addInputProductDtails.requirement,
                            metadata: {}
                        }

                    }


                    // console.log("request_final_data | ", request_final_data)

                    // this.setProductDetailsInfo(request_data)
                    // this.setStepCount(2)
                    // this.$router.push(`/edit-product-image`).catch(()=>{});

                    this.updateProduct(request_final_data).then(response => {
                        if (response.status === 200) {
                            this.loading = false;
                            let productInfo = {
                                productName: this.productName,
                                genericName: this.genericName,
                                supplier: this.supplier,
                                manufactuer: this.manufactuer,
                                productType: parseInt(this.productType),
                                country: this.country,
                                unitQuantity: parseInt(this.unitQuantity),
                                measure: parseInt(this.measure),
                                weight: parseInt(this.weight),
                                shortDesc: this.shortDesc,
                                otherDetails: this.otherDetails,
                                sellingPrice: parseInt(this.sellingPrice),
                                costPrice: parseInt(this.costPrice),
                                storageRequired: this.storageRequired,
                                requirement: this.requirement,
                                productId: this.getCatalog.id
                            }
                            this.setProductDetailsInfo(productInfo)
                            this.setStepCount(2)
                            // this.$router.push(`/edit-product-image`).catch(()=>{});
                        } else {
                            // console.log("Error | ", response)
                        }
                    }, error => {
                        this.loading = true;
                        console.log("Error | ", error)
                    })
                } else {
                    return false;
                }
            })

        },
        handleAddSupplierCancel() {
            this.isSupplierVisible = false
        },
        handleAddManufcturerCancel() {
            this.isManufacturerVisible = false
        },
        OnSelectSupplier(value) {
            // console.log("other | ", value)
            if (value === "other") {
                this.isSupplierVisible = true
            }

        },
        OnSelectManufacturer(value) {
            // console.log("other | ", value)
            if (value === "other") {
                this.isManufacturerVisible = true
            }
        },
        onChangeStorage(value) {
            return this.showRequirement = value == "true" ? true : false;
        },
    },
    created() {
        this.finalCategoryManufacturerSupplierList().then(response => {

            this.manufactuers = response[0].data.data
            this.categories = response[1].data.data
            this.suppliers = response[2].data.data

        },
            error => {
                console.log("error | ", error)
            })

        if (this.getCatalog) {
            // console.log("getCatalog | ", this.getCatalog)
            // console.log("suppliers | ", this.suppliers)

            this.onChangeStorage(this.getCatalog.isSpecial.toString())
            this.country = this.getCatalog.country;
            this.addInputProductDtails = {
                productName: this.getCatalog?.brandName,
                genericName: this.getCatalog?.genericName,
                productType: this.getCatalog?.productType.toString(),
                supplier: this.getCatalog?.supplierId,
                manufactuer: this.getCatalog?.manufacturerId,
                country: this.getCatalog.country,
                unitQuantity: this.getCatalog?.unitQuantity,
                requirement: this.getCatalog?.specialRequirement,
                measure: this.getCatalog?.unit.toString(),
                weight: this.getCatalog?.unitWeight,
                shortDesc: this.getCatalog?.shortDescription,
                otherDetails: this.getCatalog?.details,
                storageRequired: this.getCatalog?.isSpecial.toString(),
                sellingPrice: this.getCatalog?.sellingPrice,
                costPrice: this.getCatalog?.purchasePrice,
                metadata: {}
            }

            // console.log("addInputProductDtails | ", this.addInputProductDtails)
        }
    }
}
</script>

<style scoped>
.img_size {
    max-width: 56px;
    max-height: 55px;
}

.dropdownItem {
    width: 100%;
    border-radius: 5px;
}

.countryStyle {
    width: 98%;
    height: 31px;
    border-color: #ccc;
    border-radius: 5px;
}

.numberInput {
    width: 100%;
    border-radius: 5px;
}

.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}
</style>